export const PageFuelPriceData = () => {

  return (
    <>
      <h1>Fuel price data</h1>
    </>
  );
};

